
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { TbReportAnalytics } from "react-icons/tb";
import { TbVaccine } from "react-icons/tb";

export const headCells = [
    { id: "Prescription Number", numeric: true, disablePadding: false, label: "Prescription Number", showIcon: true },
    { id: "date", numeric: true, disablePadding: false, label: "Date", showIcon: true },
    { id: "Medicine", numeric: true, disablePadding: false, label: "Medicine", showIcon: true },
    { id: "medicineType", numeric: true, disablePadding: false, label: "Medicine type", showIcon: true },
    { id: "Dose", numeric: true, disablePadding: false, label: "Standard", showIcon: true },
    { id: "Strength", numeric: true, disablePadding: false, label: "Strength", showIcon: true },
    { id: "Duration", numeric: true, disablePadding: false, label: "Duration", showIcon: true },
    { id: "medicineIntakeTime", numeric: true, disablePadding: false, label: "Dosage Instructions", showIcon: true },
    { id: "Qty", numeric: true, disablePadding: false, label: "Qty", showIcon: true },
    { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
];

export const headCellsReport = [
    { id: "Title", numeric: true, disablePadding: false, label: "Title" },
    { id: "Description", numeric: true, disablePadding: false, label: "Description", showIcon: true },
    { id: "File", numeric: true, disablePadding: false, label: "File" },
    { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
];
export const headCellsVaccination = [
    { id: "formName", numeric: false, disablePadding: true, label: "Form Name", showIcon: true },
    { id: "doctorName", numeric: true, disablePadding: false, label: "Doctor", showIcon: true },
    { id: "PatientName", numeric: true, disablePadding: false, label: "Patient Name", showIcon: true },
    { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
];

export const steps = ['Vitals', 'Others', "Test Reports", 'RX (E-Prescription)', "Vaccination", 'Follow Up',];
export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            background:
                '#33B0A7',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            background:
                '#33B0A7',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));
export const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ededed',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        background:
            '#33B0A7',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        background:
            '#33B0A7',
    }),
}));


export function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
    const icons = {
        1: <SettingsIcon />,
        2: <GroupAddIcon />,
        3: <TbReportAnalytics size={25} />,
        4: <VideoLabelIcon />,
        5: <TbVaccine size={25} />,
        6: <DateRangeIcon />,
    };
    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}